export enum EApplicationType {
  ProjectsList,
  ProjectEditor,
  ProjectPreview,
  PromoPage,
}
